import { render } from "./LoginView.vue?vue&type=template&id=759072d4&scoped=true"
const script = {}

import "./LoginView.vue?vue&type=style&index=0&id=759072d4&scoped=true&lang=css"

import exportComponent from "D:\\mnry7\\Documents\\front-saberes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759072d4"]])

export default __exports__